import React from 'react';

const UnoFormat = () => (
  <svg x="0px" y="0px" viewBox="0 0 193.8 32">
    <g>
      <path
        className="st0"
        d="M97.5,15.7h-9.9c-0.5,0-1,0.2-1.4,0.6c-0.4,0.4-0.6,0.9-0.6,1.4c0,0.6,0.2,1,0.6,1.4c0.4,0.4,0.9,0.6,1.4,0.6
   h7.2v3.9h-7.2c-0.5,0-1,0.2-1.4,0.6c-0.4,0.4-0.6,0.9-0.6,1.4v5.9h-3.9v-5.9c0-1.5,0.5-2.8,1.5-4c-1-1.1-1.5-2.5-1.5-4
   c0-1.6,0.6-3,1.7-4.2c1.1-1.2,2.5-1.7,4.2-1.8h9.9V15.7z"
      />
      <path
        className="st0"
        d="M117.5,14.5c-2-2-4.4-3-7.3-3c-2.9,0-5.3,1-7.3,3c-2,2-3,4.4-3,7.3c0,2.9,1,5.3,3,7.3c2,2,4.4,3,7.3,3
   c2.9,0,5.3-1,7.3-3c2-2,3-4.4,3-7.3C120.5,18.8,119.5,16.4,117.5,14.5C117.5,14.5,119.5,16.4,117.5,14.5 M114.6,26
   c-1.2,1.2-2.7,1.8-4.4,1.8c-1.7,0-3.2-0.6-4.4-1.8c-1.2-1.2-1.8-2.7-1.8-4.4c0-1.7,0.6-3.1,1.8-4.3c1.2-1.2,2.7-1.8,4.4-1.8
   c1.7,0,3.2,0.6,4.4,1.8c1.2,1.2,1.8,2.6,1.8,4.3C116.4,23.4,115.8,24.8,114.6,26C114.6,26,115.8,24.8,114.6,26"
      />
      <path
        className="st0"
        d="M133.3,11.8v4h-4c-0.5,0-1,0.2-1.5,0.6c-0.4,0.4-0.6,0.8-0.6,1.4v13.9h-4V17.7c0-1.6,0.6-3,1.8-4.2
   c1.2-1.2,2.6-1.7,4.3-1.8H133.3z"
      />
      <path
        className="st0"
        d="M156.6,31.6h-3.9V17.4c0-0.5-0.2-1-0.6-1.4c-0.4-0.4-0.9-0.6-1.4-0.6s-1,0.2-1.4,0.6c-0.4,0.4-0.5,0.9-0.6,1.4
   l0,14.2h-3.9V17.4c0-0.5-0.2-1-0.6-1.4c-0.4-0.4-0.9-0.6-1.4-0.6c-0.5,0-1,0.2-1.4,0.6c-0.4,0.4-0.6,0.9-0.6,1.4v14.2h-3.9V17.4
   c0-1.6,0.6-3,1.7-4.2c1.1-1.2,2.5-1.7,4.2-1.8c1.5,0,2.8,0.5,4,1.6c1.1-1,2.4-1.5,4-1.6c1.6,0,3,0.6,4.2,1.8
   c1.2,1.1,1.7,2.5,1.7,4.2V31.6z"
      />
      <path
        className="st0"
        d="M178.7,21.7c1-1.1,1.5-2.4,1.5-4c0-1.7-0.6-3.1-1.8-4.2c-1.1-1.2-2.5-1.8-4.2-1.8h-11.4v4h11.4
   c0.6,0,1,0.2,1.4,0.6c0.4,0.4,0.6,0.8,0.6,1.3c0,0.6-0.2,1-0.6,1.4c-0.4,0.4-0.9,0.6-1.4,0.6h-7.9c-1.7,0-3.1,0.6-4.2,1.8
   c-1.2,1.2-1.7,2.5-1.7,4.2c0,1.7,0.6,3.1,1.7,4.2c1.2,1.2,2.6,1.7,4.2,1.7h7.9c1.7,0,3.1-0.6,4.2-1.7c1.2-1.2,1.8-2.6,1.8-4.2
   C180.2,24.2,179.7,22.8,178.7,21.7C178.7,21.7,179.7,22.8,178.7,21.7 M175.6,27.1c-0.4,0.4-0.9,0.6-1.4,0.6h-7.9
   c-0.6,0-1-0.2-1.4-0.6c-0.4-0.4-0.6-0.9-0.6-1.4c0-0.6,0.2-1,0.6-1.4c0.4-0.4,0.9-0.6,1.4-0.6h7.9c0.6,0,1,0.2,1.4,0.6
   c0.4,0.4,0.6,0.9,0.6,1.4C176.2,26.2,176,26.7,175.6,27.1C175.6,27.1,176,26.7,175.6,27.1"
      />
      <path
        className="st0"
        d="M193.8,31.6h-4c-1.6,0-3-0.6-4.2-1.7c-1.2-1.1-1.7-2.5-1.8-4.2V11.8h4v3.9h6v4.1h-6v6c0,0.5,0.2,1,0.6,1.3
   c0.4,0.4,0.9,0.5,1.5,0.6h4V31.6z"
      />
      <path
        className="st0"
        d="M50.2,21.3c0-1.2-0.4-2.2-1.2-3.1c-0.8-0.8-1.8-1.3-3-1.3c-1.2,0-2.2,0.4-3.1,1.3c-0.8,0.8-1.3,1.8-1.3,3v10.3
   H36V21.3c0-2.7,1-5.1,2.9-7c1.9-1.9,4.3-2.9,7-2.9c2.7,0,5,1,7,2.9c1.9,1.9,2.9,4.3,2.9,7v10.3h-5.7V21.3z"
      />
      <path
        className="st0"
        d="M71.7,24.8c-0.9,0.9-1.9,1.3-3.1,1.3c-1.3,0-2.3-0.5-3.2-1.3c-0.9-0.9-1.3-1.9-1.3-3.1c0-1.3,0.4-2.3,1.3-3.2
   c0.9-0.9,1.9-1.3,3.2-1.3c1.2,0,2.3,0.4,3.2,1.3c0.9,0.9,1.3,1.9,1.3,3.2C73,22.9,72.5,23.9,71.7,24.8 M75.8,14.5c-2-2-4.4-3-7.3-3
   c-2.9,0-5.3,1-7.3,3c-2,2-3,4.4-3,7.3c0,2.9,1,5.3,3,7.3c2,2,4.5,3,7.3,3c2.9,0,5.3-1,7.3-3c2-2,3-4.4,3-7.3
   C78.8,18.8,77.8,16.4,75.8,14.5"
      />
      <path
        className="st0"
        d="M27.3,11.8v10.3c0,1.2-0.5,2.2-1.3,3.1c-0.9,0.8-1.9,1.3-3.1,1.3c-1.2,0-2.2-0.4-3-1.2
   c-0.8-0.8-1.2-1.9-1.2-3.1V11.8h0c-0.9,2.8-2.4,4.7-5.7,6v4.3c0,2.8,1,5.1,2.9,7c1.9,1.9,4.3,2.9,7,2.9c2.8,0,5.1-1,7-2.9
   c1.9-1.9,2.9-4.3,2.9-7V11.8H27.3z"
      />
      <path
        className="st0"
        d="M18.2,9.6c0-4.3-3.5-7.8-7.8-7.8c-0.8,0-1.6,0.1-2.3,0.3l-0.4,1c0.8-0.3,1.7-0.5,2.7-0.5c3.9,0,7,3.1,7,7
   c0,1.4-0.2,1.5-0.2,2.1h-4V16c-1.1,0.3-1.2,0.5-2.8,0.5c-3.7,0-6.7-2.9-7-6.6H2.7c0.2,4.1,3.6,7.4,7.8,7.4
   C14.7,17.3,18.2,13.9,18.2,9.6"
      />
      <polygon className="st0" points="8.5,0 0,3.9 2.9,3.9 0.5,9.8 4.5,9.8" />
    </g>
  </svg>
);

export default UnoFormat;
